<div>
    <app-step-progress [steps]="steps"></app-step-progress>

    <div *ngIf="userOrderStatus === approvedStatusNumber">
        <app-page-title [title]="'order completed'"></app-page-title>
        <div class="row pl-4">
            <div
                *ngIf="!loading; else isLoading"
                class="col-md-12"
            >
                <p>Order Number: <strong>{{lastOrderNumber}}</strong></p>
                <p>Thank you for your order. A confirmation email with the order details will be sent to you soon.</p>
                <div>
                    <p>View order details in your <a [routerLink]="['/my-account']">account.</a></p>
                </div>
                <p *ngIf="brandId === BrandEnum.CELPIP">If you have any questions, please contact us at info@celpip.ca, 1-800-958-5186 or 778-327-6854.</p>
                <p *ngIf="brandId === BrandEnum.CAEL">If you have any questions, please contact us at info@cael.ca, 1-855-520-2235 or 604-674-8664.</p>
            </div>
            <ng-template #isLoading>
                <div class="row">
                    <div class="col-md-12">
                        <p>Order Number: <strong>{{lastOrderNumber}}</strong></p>
                        <i class="fa fa-spinner fa-spin"></i><span> Loading order information...</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>

    <div *ngIf=orderIncompleted>
        <app-incomplete-order [brandId]="brandId"></app-incomplete-order>
    </div>
</div>
